// @flow

import { type BrazilianDocumentType } from './types';

const LETTER_PATTERN = /[A-Za-z]/u;
const FORMATTING_PATTERN = /[.\-/]/u;

export function getDocumentTypeFromFormattedValue(value: ?string): BrazilianDocumentType {
  if (!value) {
    return 'cpf';
  }

  return hasLetter(value) || value.length > 14 ? 'cnpj' : 'cpf';
}

export function getDocumentTypeFromRawValue(value: ?string): BrazilianDocumentType {
  if (!value) {
    return 'cpf';
  }

  return hasLetter(value) || value.length > 11 ? 'cnpj' : 'cpf';
}

export function getDocumentTypeInferredFromValue(value: ?string): BrazilianDocumentType {
  return !value || !isFormatted(value)
    ? getDocumentTypeFromRawValue(value)
    : getDocumentTypeFromFormattedValue(value);
}

function hasLetter(value: string): boolean {
  return LETTER_PATTERN.test(value);
}

function isFormatted(value: string): boolean {
  return FORMATTING_PATTERN.test(value);
}
